import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Section, Card, Button, Alert, Input, Label } from "../design-system";
import { useAuth } from "../auth/AuthProvider";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ChangePasswordPage() {
  const { user, token, logout } = useAuth();
  const nav = useNavigate();
  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [success, setSuccess] = useState(false);

  const forced = user?.must_change_password;

  const submit = async () => {
    setErr(null);
    if (newPw.length < 10) { setErr("La nuova password deve avere almeno 10 caratteri."); return; }
    if (newPw !== confirmPw) { setErr("Le due nuove password non coincidono."); return; }
    if (newPw === currentPw) { setErr("La nuova password deve essere diversa da quella attuale."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/api/auth/change-password`,
        { current_password: currentPw, new_password: newPw },
        { headers: { Authorization: `Bearer ${token}` } });
      setSuccess(true);
      // Force logout+login so the token reflects updated user state
      setTimeout(async () => { await logout(); nav("/login"); }, 2000);
    } catch (e) {
      const detail = e?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : detail?.code || e.message;
      setErr(
        msg === "new_password_too_short" ? "La nuova password è troppo corta." :
        msg === "new_password_same_as_current" ? "La nuova password deve essere diversa." :
        msg === "Current password wrong" ? "Password attuale non corretta." :
        `Errore: ${msg}`
      );
    } finally { setBusy(false); }
  };

  return (
    <Section title={forced ? "Imposta una nuova password" : "Cambia password"}
             subtitle={forced ? "Per proseguire, è necessario modificare la password temporanea." : "Aggiorna la tua password"}
             data-testid="change-password-page">
      <div style={{ maxWidth: 480, margin: "0 auto" }}>
        {success ? (
          <Alert tone="success" data-testid="cp-success">
            Password aggiornata con successo. Verrai reindirizzato al login…
          </Alert>
        ) : (
          <Card>
            <Card.Body>
              {forced && (
                <Alert tone="warning">
                  Password temporanea rilevata. Cambiala ora per continuare.
                </Alert>
              )}
              {err && <Alert variant="danger" data-testid="cp-error">{err}</Alert>}
              <div style={{ display: "grid", gap: 12 }}>
                <div>
                  <Label>Password attuale *</Label>
                  <Input type="password" value={currentPw} data-testid="cp-current"
                         onChange={(e) => setCurrentPw(e.target.value)} autoFocus />
                </div>
                <div>
                  <Label>Nuova password *</Label>
                  <Input type="password" value={newPw} data-testid="cp-new"
                         onChange={(e) => setNewPw(e.target.value)} />
                  <div className="muted" style={{ fontSize: ".8rem" }}>Minimo 10 caratteri.</div>
                </div>
                <div>
                  <Label>Conferma nuova password *</Label>
                  <Input type="password" value={confirmPw} data-testid="cp-confirm"
                         onChange={(e) => setConfirmPw(e.target.value)}
                         onKeyDown={(e) => e.key === "Enter" && submit()} />
                </div>
                <Button variant="primary" onClick={submit} loading={busy} disabled={busy}
                        data-testid="cp-submit">
                  {busy ? "Attendi…" : "Cambia password"}
                </Button>
                {!forced && (
                  <Button variant="ghost" onClick={() => nav(-1)}>Annulla</Button>
                )}
              </div>
            </Card.Body>
          </Card>
        )}
      </div>
    </Section>
  );
}
